import { Controller } from "@hotwired/stimulus"

// Downloads backup codes as a plain text file.
// Reads codes from DOM targets instead of a data attribute to avoid
// unnecessary exposure of backup codes in the HTML (finding #8).
export default class extends Controller {
  static targets = ["code"]
  static values = { filename: { type: String, default: "lucanto-backup-codes.txt" } }

  download() {
    const codes = this.codeTargets.map((el) => el.textContent.trim()).join("\n")
    const blob = new Blob([codes], { type: "text/plain;charset=utf-8" })
    const url = URL.createObjectURL(blob)

    const link = document.createElement("a")
    link.href = url
    link.download = this.filenameValue
    link.click()

    URL.revokeObjectURL(url)
  }
}
